export function isPublicRfqResponsePath(pathname: string) {
  return /^\/rfq\/respond\/[^/]+\/?$/.test(pathname)
}
